import * as Panels from '../../util/panels';
import React from 'react';
import {DataFramesConfig} from './common';
import * as Query from '../../util/queryts';
import {toRunsDataQuery} from '../../containers/RunsDataLoader';
export type {DataFramesConfig};

const PANEL_TYPE = 'Data Frame Table';

function transformQuery(query: Query.Query, _: DataFramesConfig) {
  const result = toRunsDataQuery(
    query,
    {selectionsAsFilters: true},
    {fullSummary: true}
  );
  return result;
}

export const Spec: Panels.PanelSpec<typeof PANEL_TYPE, DataFramesConfig> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery,
};
